import { useState } from '#imports'

const LEAD_COLLECTION_POPUP_DISPLAYED_KEY = 'lead-collection-popup-displayed'

/**
 * Shared, reactive "the lead-collection popup is actually on screen" flag.
 *
 * `activePopup` (see useLeadCollectionPopup.ts) is eligibility, not
 * visibility: it's already truthy during the 10s pre-show delay, and it
 * stays truthy after a dismiss because the persisted state it reads isn't
 * reactive. The live-shopping widget needs the real on-screen state so it
 * only yields its bottom-left corner while the popup is genuinely there.
 */
export function useLeadCollectionPopupVisibility() {
  return useState<boolean>(LEAD_COLLECTION_POPUP_DISPLAYED_KEY, () => false)
}
